export const MobileAccountIcon = defineComponent({
  setup() {
    return () => (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M9.86914 1.51562C10.0646 1.49075 10.2691 1.52442 10.4365 1.62793L17.8496 6.43164C18.0327 6.57366 18.148 6.78418 18.166 7.0166V17.7832C18.124 18.1697 17.8156 18.477 17.4258 18.5088H2.56543C2.17673 18.4666 1.87376 18.1583 1.83984 17.7686V7.0166C1.85663 6.79374 1.96867 6.58717 2.13867 6.44531L9.56934 1.62793C9.65315 1.58081 9.77416 1.52783 9.86914 1.51562ZM3.47461 7.49023V16.8516L3.49805 16.875H16.5088L16.5312 16.8516V7.49023L10.0029 3.37988L3.47461 7.49023ZM14.498 13.1963V14.8457H5.50391V13.1963H14.498Z"
          fill="var(--colors-primary)"
        />
      </svg>
    )
  },
})
